/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration Layer (BOL) API
 * Business Orchestration layer (BOL) API. Public part, exposed to BOL client applications.  Glossary | Definition -- | -- <strong>Logistics Object</strong> | A resource in the BOL system that represents a business entity, such as a QuotationRequest, Quotation, or Service. Logistics Objects are managed through the BOL API and can be accessed or modified by Users based on their permissions i.e. based on their AD Entra ID roles and ACL (Access Control List) modes. <strong>Member</strong> | A data owner in the BOL system, uniquely identified by its `memberIdentifier`. Members are used to manage access control and ownership of Logistics Objects. <strong>User</strong> | A person or entity that interacts with the BOL system, typically through a client application, and beeing authenticated. Users are associated with Members and can perform actions on Logistics Objects based on their access level. User access token includes the Member identifier as part of roles claims. Each path in the API is protected by a custom role defined in AD Entra ID, and operations on Logistics Objects are protected by specific Access modes defined by members. <strong>Access Control</strong> | The mechanism by which the BOL system restricts access to API paths and resources based on the identity of the User and their associated Member. Access control is enforced through AD Entra ID roles and ACL (Access Control List) modes defined for every single Logistics Object. <strong>ACL (Access Control List)</strong> | A set of authorizations that define what actions a User can perform on a Logistics Object. The level of access granted to Users is determined by ACL modes defined in authorizations for specific Logistics Objects. ACL Modes are not directly associated with Users but rather with Members, which are the data owners of Logistics Objects. Each Logistics Object has an ACL that specifies the access modes for different Members. Members need to exist in the BOL system to be granted access to Logistics Objects. <strong>ACL Mode</strong> | The specific level of access control applied to a Logistics Object, determining what actions can be performed by Users. ACL modes are defined for each Logistics Object by `memberIdentifier` and include `READ`, `WRITE`, and `CONTROL`. Each mode includes access granted by the modes under it, so `CONTROL` includes `WRITE` and `READ`, and `WRITE` includes `READ`. <strong>Change Request</strong> | A request to modify a Logistics Object, which is processed by the BOL system. Change requests are created when a User wants to update an existing Logistics Object, and they are subject to approval and application by the system. All changes to Logistics Objects are done through change requests. This allows for a controlled and auditable process of modifications. <strong>Host</strong> | A server alias in the BOL system, used to abstract URI values internally. This allows for flexibility in the underlying infrastructure when migrating or changing server configurations. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ACL,
  ACLAuthorization,
  ACLAuthorizationRequest,
  ChangeRequest,
  ChangeRequestCreateRequest,
  ChangeRequestPatchRequest,
  Consignment,
  ConsignmentResponse,
  ErrorResponse,
  EventCreateRequest,
  LogisticsObjectMetadata,
  PaginatedChangeRequests,
  PaginatedEvents,
  SearchConsignmentsRequest,
  SearchConsignmentsResponse,
} from '../models/index';
import {
    ACLFromJSON,
    ACLToJSON,
    ACLAuthorizationFromJSON,
    ACLAuthorizationToJSON,
    ACLAuthorizationRequestFromJSON,
    ACLAuthorizationRequestToJSON,
    ChangeRequestFromJSON,
    ChangeRequestToJSON,
    ChangeRequestCreateRequestFromJSON,
    ChangeRequestCreateRequestToJSON,
    ChangeRequestPatchRequestFromJSON,
    ChangeRequestPatchRequestToJSON,
    ConsignmentFromJSON,
    ConsignmentToJSON,
    ConsignmentResponseFromJSON,
    ConsignmentResponseToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    EventCreateRequestFromJSON,
    EventCreateRequestToJSON,
    LogisticsObjectMetadataFromJSON,
    LogisticsObjectMetadataToJSON,
    PaginatedChangeRequestsFromJSON,
    PaginatedChangeRequestsToJSON,
    PaginatedEventsFromJSON,
    PaginatedEventsToJSON,
    SearchConsignmentsRequestFromJSON,
    SearchConsignmentsRequestToJSON,
    SearchConsignmentsResponseFromJSON,
    SearchConsignmentsResponseToJSON,
} from '../models/index';

export interface CreateChangeRequestOnConsignmentByIdRequest {
    consignmentId: string;
    contentType: CreateChangeRequestOnConsignmentByIdContentTypeEnum;
    changeRequestCreateRequest: ChangeRequestCreateRequest;
    source?: boolean;
    accept?: CreateChangeRequestOnConsignmentByIdAcceptEnum;
    traceparent?: string;
}

export interface CreateConsignmentRequest {
    contentType: CreateConsignmentContentTypeEnum;
    xBOLMemberIdentifier: string;
    consignment: Consignment;
    id?: string;
    source?: boolean;
    accept?: CreateConsignmentAcceptEnum;
    traceparent?: string;
    xBOLACLAuthorizations?: string;
}

export interface CreateConsignmentEventRequest {
    consignmentId: string;
    contentType: CreateConsignmentEventContentTypeEnum;
    xBOLMemberIdentifier: string;
    eventCreateRequest: EventCreateRequest;
    accept?: CreateConsignmentEventAcceptEnum;
    traceparent?: string;
}

export interface DeleteConsignmentACLAuthorizationByMemberIdRequest {
    consignmentId: string;
    memberId: string;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    traceparent?: string;
}

export interface DeleteConsignmentByIdRequest {
    consignmentId: string;
    traceparent?: string;
}

export interface DeleteConsignmentEventByIdRequest {
    consignmentId: string;
    eventId: string;
    xBOLMemberIdentifier: string;
    traceparent?: string;
}

export interface GetChangeRequestOnConsignmentByIdRequest {
    consignmentId: string;
    changeRequestId: string;
    accept?: GetChangeRequestOnConsignmentByIdAcceptEnum;
    traceparent?: string;
}

export interface GetConsignmentACLAuthorizationByMemberIdRequest {
    consignmentId: string;
    memberId: string;
    at?: string;
    aclRevision?: string;
    accept?: GetConsignmentACLAuthorizationByMemberIdAcceptEnum;
    traceparent?: string;
}

export interface GetConsignmentACLByIdRequest {
    consignmentId: string;
    at?: string;
    revision?: string;
    accept?: GetConsignmentACLByIdAcceptEnum;
    traceparent?: string;
}

export interface GetConsignmentByIdRequest {
    consignmentId: string;
    at?: string;
    revision?: string;
    accept?: GetConsignmentByIdAcceptEnum;
    traceparent?: string;
}

export interface GetConsignmentEventsRequest {
    consignmentId: string;
    limit?: number;
    offset?: number;
    startAt?: Date;
    endAt?: Date;
    code?: string;
    type?: string;
    accept?: GetConsignmentEventsAcceptEnum;
    traceparent?: string;
}

export interface GetConsignmentMetadataByIdRequest {
    consignmentId: string;
    accept?: GetConsignmentMetadataByIdAcceptEnum;
    traceparent?: string;
}

export interface ListChangeRequestsOfConsignmentByIdRequest {
    consignmentId: string;
    limit?: number;
    offset?: number;
    accept?: ListChangeRequestsOfConsignmentByIdAcceptEnum;
    traceparent?: string;
}

export interface PatchConsignmentByIdRequest {
    consignmentId: string;
    contentType: PatchConsignmentByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    consignment: Consignment;
    revision?: string;
    accept?: PatchConsignmentByIdAcceptEnum;
    traceparent?: string;
}

export interface SearchConsignmentGetRequest {
    id?: string;
    searchBody?: SearchConsignmentsRequest;
    accept?: SearchConsignmentGetAcceptEnum;
    traceparent?: string;
}

export interface SearchConsignmentsPostRequest {
    contentType: SearchConsignmentsPostContentTypeEnum;
    searchConsignmentsRequest: SearchConsignmentsRequest;
    limit?: number;
    offset?: number;
    accept?: SearchConsignmentsPostAcceptEnum;
    traceparent?: string;
}

export interface UpdateChangeRequestOnConsignmentByIdRequest {
    consignmentId: string;
    changeRequestId: string;
    contentType: UpdateChangeRequestOnConsignmentByIdContentTypeEnum;
    changeRequestPatchRequest: ChangeRequestPatchRequest;
    accept?: UpdateChangeRequestOnConsignmentByIdAcceptEnum;
    traceparent?: string;
}

export interface UpdateConsignmentByIdRequest {
    consignmentId: string;
    contentType: UpdateConsignmentByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    consignment: Consignment;
    revision?: string;
    accept?: UpdateConsignmentByIdAcceptEnum;
    traceparent?: string;
}

export interface UpsertConsignmentACLAuthorizationByIdRequest {
    consignmentId: string;
    contentType: UpsertConsignmentACLAuthorizationByIdContentTypeEnum;
    xBOLMemberIdentifier: string;
    aclRevision?: string;
    accept?: UpsertConsignmentACLAuthorizationByIdAcceptEnum;
    traceparent?: string;
    aCLAuthorizationRequest?: ACLAuthorizationRequest;
}

/**
 * 
 */
export class LogisticsObjectsConsignmentsApi extends runtime.BaseAPI {

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific Consignment resource, identified by its `ConsignmentId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the Consignment resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a Consignment resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the Consignment resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a Consignment
     */
    async createChangeRequestOnConsignmentByIdRaw(requestParameters: CreateChangeRequestOnConsignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['consignmentId'] == null) {
            throw new runtime.RequiredError(
                'consignmentId',
                'Required parameter "consignmentId" was null or undefined when calling createChangeRequestOnConsignmentById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createChangeRequestOnConsignmentById().'
            );
        }

        if (requestParameters['changeRequestCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestCreateRequest',
                'Required parameter "changeRequestCreateRequest" was null or undefined when calling createChangeRequestOnConsignmentById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/consignments/{consignmentId}/change-requests`;
        urlPath = urlPath.replace(`{${"consignmentId"}}`, encodeURIComponent(String(requestParameters['consignmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestCreateRequestToJSON(requestParameters['changeRequestCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a change request on a specific Consignment resource, identified by its `ConsignmentId`.  The change request uses the JSON Patch format as specified in [RFC 6902](https://datatracker.ietf.org/doc/html/rfc6902), enabling clients to submit a set of operations to modify the Consignment resource.  Client uers must have the provided `requestorMemberIdentifier` as part of their own member identifiers.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode or above is required to create a change request on a Consignment resource.   - **Note**: The `WRITE` mode is sufficient for creating change requests, but higher modes like `CONTROL` or `Admin` can also be used.   - With `CONTROL` mode, the change request will be automatically accepted and applied, updating the Consignment resource.   - With `WRITE` mode, the change request will be created but not applied automatically. The change request must then be accepted or rejected using the `PATCH` method on the change request resource. 
     * Create a change request on a Consignment
     */
    async createChangeRequestOnConsignmentById(requestParameters: CreateChangeRequestOnConsignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest | null | undefined > {
        const response = await this.createChangeRequestOnConsignmentByIdRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  This endpoint allows the creation of a new Consignment.  When creating a Consignment, the value of the header `X-BOL-Member-Identifier` defines the Consignment\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a Consignment, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the Consignment and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the Consignment, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the Consignment.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a Consignment
     */
    async createConsignmentRaw(requestParameters: CreateConsignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConsignmentResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createConsignment().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createConsignment().'
            );
        }

        if (requestParameters['consignment'] == null) {
            throw new runtime.RequiredError(
                'consignment',
                'Required parameter "consignment" was null or undefined when calling createConsignment().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['source'] = requestParameters['source'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (requestParameters['xBOLACLAuthorizations'] != null) {
            headerParameters['X-BOL-ACL-authorizations'] = String(requestParameters['xBOLACLAuthorizations']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/consignments`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConsignmentToJSON(requestParameters['consignment']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConsignmentResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows the creation of a new Consignment.  When creating a Consignment, the value of the header `X-BOL-Member-Identifier` defines the Consignment\'s owner. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  When creating a Consignment, its ACL (Access Control List) is initialized with a default set of authorizations. The ACL defines which Members have access to the Consignment and what actions they can perform.  By default, the ACL is initialized with access for the Member that creates the Consignment, granting it `CONTROL` access mode. This means that the Member can manage the ACL and perform any operation on the Consignment.  It is possible to use the header `X-BOL-ACL-authorizations` to specify additional authorizations for the ACL on initialization. The header must contain a JSON array of authorizations to apply in addition to the default one.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Create`. 
     * Create a Consignment
     */
    async createConsignment(requestParameters: CreateConsignmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConsignmentResponse | null | undefined > {
        const response = await this.createConsignmentRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return null;
            case 200:
                return await response.value();
            default:
                return await response.value();
        }
    }

    /**
     * ## Description  Create an Event of a Consignment by `consignmentId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a Consignment resource. 
     * Create an Event of a Consignment
     */
    async createConsignmentEventRaw(requestParameters: CreateConsignmentEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['consignmentId'] == null) {
            throw new runtime.RequiredError(
                'consignmentId',
                'Required parameter "consignmentId" was null or undefined when calling createConsignmentEvent().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling createConsignmentEvent().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling createConsignmentEvent().'
            );
        }

        if (requestParameters['eventCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'eventCreateRequest',
                'Required parameter "eventCreateRequest" was null or undefined when calling createConsignmentEvent().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/consignments/{consignmentId}/events`;
        urlPath = urlPath.replace(`{${"consignmentId"}}`, encodeURIComponent(String(requestParameters['consignmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EventCreateRequestToJSON(requestParameters['eventCreateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  Create an Event of a Consignment by `consignmentId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `WRITE` mode is required to create an event on a Consignment resource. 
     * Create an Event of a Consignment
     */
    async createConsignmentEvent(requestParameters: CreateConsignmentEventRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createConsignmentEventRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a Consignment resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the Consignment resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a Consignment resource. 
     * Delete an authorization of an access control list of a Consignment by memberId
     */
    async deleteConsignmentACLAuthorizationByMemberIdRaw(requestParameters: DeleteConsignmentACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['consignmentId'] == null) {
            throw new runtime.RequiredError(
                'consignmentId',
                'Required parameter "consignmentId" was null or undefined when calling deleteConsignmentACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling deleteConsignmentACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deleteConsignmentACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/consignments/{consignmentId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"consignmentId"}}`, encodeURIComponent(String(requestParameters['consignmentId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific authorization from the Access Control List (ACL) of a Consignment resource for a given member, identified by the `memberId`. This removes the access granted to the specified member for the Logistics Object.  - When an ACL authorization is deleted, the member will lose access to the Consignment resource according to the authorization that was removed. - This operation should be performed with caution as it affects access control to the resource. - The requesting user must have sufficient privileges to modify the ACL.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to delete authorizations from the ACL of a Consignment resource. 
     * Delete an authorization of an access control list of a Consignment by memberId
     */
    async deleteConsignmentACLAuthorizationByMemberId(requestParameters: DeleteConsignmentACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteConsignmentACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific Consignment resource, identified by its `ConsignmentId`.  - When a Consignment is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a Consignment resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a Consignment resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a Consignment resource. 
     * Delete a Consignment by consignmentId
     */
    async deleteConsignmentByIdRaw(requestParameters: DeleteConsignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['consignmentId'] == null) {
            throw new runtime.RequiredError(
                'consignmentId',
                'Required parameter "consignmentId" was null or undefined when calling deleteConsignmentById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/consignments/{consignmentId}`;
        urlPath = urlPath.replace(`{${"consignmentId"}}`, encodeURIComponent(String(requestParameters['consignmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific Consignment resource, identified by its `ConsignmentId`.  - When a Consignment is deleted, it is permanently removed from the system and cannot be recovered. This operation should be performed with caution. - Deletion of a Consignment resource is allowed even if the resource is referenced by any other resources or if the references are also deleted. - Deleting a Consignment resource also deletes any associated change requests and metadata, including the ACL and authorizations, as well as all Logistics Object Events.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Delete`. - **ACL Mode**: `CONTROL` mode is required to delete a Consignment resource. 
     * Delete a Consignment by consignmentId
     */
    async deleteConsignmentById(requestParameters: DeleteConsignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteConsignmentByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a Consignment resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a Consignment resource. 
     * Delete an event of a Consignment by id
     */
    async deleteConsignmentEventByIdRaw(requestParameters: DeleteConsignmentEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['consignmentId'] == null) {
            throw new runtime.RequiredError(
                'consignmentId',
                'Required parameter "consignmentId" was null or undefined when calling deleteConsignmentEventById().'
            );
        }

        if (requestParameters['eventId'] == null) {
            throw new runtime.RequiredError(
                'eventId',
                'Required parameter "eventId" was null or undefined when calling deleteConsignmentEventById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling deleteConsignmentEventById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/consignments/{consignmentId}/events/{eventId}`;
        urlPath = urlPath.replace(`{${"consignmentId"}}`, encodeURIComponent(String(requestParameters['consignmentId'])));
        urlPath = urlPath.replace(`{${"eventId"}}`, encodeURIComponent(String(requestParameters['eventId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * ## Description  This endpoint allows the deletion of a specific event of a Consignment resource by its `eventId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role \'BOL.LOGISTICS-OBJECTS.Update\'. - **ACL Mode**: `CONTROL` mode is required to delete an event of a Consignment resource. 
     * Delete an event of a Consignment by id
     */
    async deleteConsignmentEventById(requestParameters: DeleteConsignmentEventByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteConsignmentEventByIdRaw(requestParameters, initOverrides);
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given Consignment, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the Consignment resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a Consignment by changeRequestId
     */
    async getChangeRequestOnConsignmentByIdRaw(requestParameters: GetChangeRequestOnConsignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['consignmentId'] == null) {
            throw new runtime.RequiredError(
                'consignmentId',
                'Required parameter "consignmentId" was null or undefined when calling getChangeRequestOnConsignmentById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling getChangeRequestOnConsignmentById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/consignments/{consignmentId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"consignmentId"}}`, encodeURIComponent(String(requestParameters['consignmentId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a specific ChangeRequest associated with a given Consignment, identified by its `changeRequestId`. This endpoint allows clients to access the details and status of a particular change request, including the set of modifications proposed or applied to the Consignment resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the details of a ChangeRequest resource. 
     * Get a change request on a Consignment by changeRequestId
     */
    async getChangeRequestOnConsignmentById(requestParameters: GetChangeRequestOnConsignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.getChangeRequestOnConsignmentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a Consignment resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a Consignment resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a Consignment by memberId
     */
    async getConsignmentACLAuthorizationByMemberIdRaw(requestParameters: GetConsignmentACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['consignmentId'] == null) {
            throw new runtime.RequiredError(
                'consignmentId',
                'Required parameter "consignmentId" was null or undefined when calling getConsignmentACLAuthorizationByMemberId().'
            );
        }

        if (requestParameters['memberId'] == null) {
            throw new runtime.RequiredError(
                'memberId',
                'Required parameter "memberId" was null or undefined when calling getConsignmentACLAuthorizationByMemberId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/consignments/{consignmentId}/acl/authorizations/{memberId}`;
        urlPath = urlPath.replace(`{${"consignmentId"}}`, encodeURIComponent(String(requestParameters['consignmentId'])));
        urlPath = urlPath.replace(`{${"memberId"}}`, encodeURIComponent(String(requestParameters['memberId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific authorization from the Access Control List (ACL) of a Consignment resource for a given member, identified by the `memberId`. This allows clients to check the specific access mode granted to a particular member for the Logistics Object.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL authorization of a Consignment resource. - **Note**: Only the `CONTROL` mode allows to get any member authorization. In `READ`, `WRITE` modes, only the authorization for the authenticated member user can be retrieved. 
     * Get an authorization of an access control list of a Consignment by memberId
     */
    async getConsignmentACLAuthorizationByMemberId(requestParameters: GetConsignmentACLAuthorizationByMemberIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.getConsignmentACLAuthorizationByMemberIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific Consignment resource, identified by its `ConsignmentId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the Consignment and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a Consignment resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a Consignment for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getConsignmentACLByIdRaw(requestParameters: GetConsignmentACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACL>> {
        if (requestParameters['consignmentId'] == null) {
            throw new runtime.RequiredError(
                'consignmentId',
                'Required parameter "consignmentId" was null or undefined when calling getConsignmentACLById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/consignments/{consignmentId}/acl`;
        urlPath = urlPath.replace(`{${"consignmentId"}}`, encodeURIComponent(String(requestParameters['consignmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves the Access Control List (ACL) for a specific Consignment resource, identified by its `ConsignmentId`. The ACL details the authorizations for the authenticated member user.  This endpoint enables clients to review which members have access to the Consignment and under which access modes, supporting fine-grained authorization.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the ACL of a Consignment resource. - **Note**: Only the `CONTROL` mode allows to get the Logistics Object ACL with all authorizations. In `READ`, `WRITE`, `READ` mode, the ACL will only contain authorizations for the authenticated member user. 
     * Get ACL of a Consignment for the authenticated member user. The ACL with the latest revision is returned by default.
     */
    async getConsignmentACLById(requestParameters: GetConsignmentACLByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACL> {
        const response = await this.getConsignmentACLByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves a specific Consignment by its `ConsignmentId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this Consignment resource. 
     * Get a Consignment by consignmentId
     */
    async getConsignmentByIdRaw(requestParameters: GetConsignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConsignmentResponse>> {
        if (requestParameters['consignmentId'] == null) {
            throw new runtime.RequiredError(
                'consignmentId',
                'Required parameter "consignmentId" was null or undefined when calling getConsignmentById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['at'] != null) {
            queryParameters['at'] = requestParameters['at'];
        }

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/consignments/{consignmentId}`;
        urlPath = urlPath.replace(`{${"consignmentId"}}`, encodeURIComponent(String(requestParameters['consignmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConsignmentResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves a specific Consignment by its `ConsignmentId`.  __Note:__ The `revision` and `at` query parameters cannot be used at the same time. If both are provided simultaneously, the request will result in a `Bad Request` error.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this Consignment resource. 
     * Get a Consignment by consignmentId
     */
    async getConsignmentById(requestParameters: GetConsignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConsignmentResponse> {
        const response = await this.getConsignmentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  List Events of a Consignment by `consignmentId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a Consignment resource. 
     * List Events of a Consignment
     */
    async getConsignmentEventsRaw(requestParameters: GetConsignmentEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedEvents>> {
        if (requestParameters['consignmentId'] == null) {
            throw new runtime.RequiredError(
                'consignmentId',
                'Required parameter "consignmentId" was null or undefined when calling getConsignmentEvents().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['startAt'] != null) {
            queryParameters['startAt'] = requestParameters['startAt'];
        }

        if (requestParameters['endAt'] != null) {
            queryParameters['endAt'] = requestParameters['endAt'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/consignments/{consignmentId}/events`;
        urlPath = urlPath.replace(`{${"consignmentId"}}`, encodeURIComponent(String(requestParameters['consignmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedEventsFromJSON(jsonValue));
    }

    /**
     * ## Description  List Events of a Consignment by `consignmentId`, ordered by their `actualDateTime`, from newest to oldest. Events are returned in a paginated format.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the events of a Consignment resource. 
     * List Events of a Consignment
     */
    async getConsignmentEvents(requestParameters: GetConsignmentEventsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedEvents> {
        const response = await this.getConsignmentEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific Consignment by its `ConsignmentId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a Consignment metadata by consignmentId
     */
    async getConsignmentMetadataByIdRaw(requestParameters: GetConsignmentMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogisticsObjectMetadata>> {
        if (requestParameters['consignmentId'] == null) {
            throw new runtime.RequiredError(
                'consignmentId',
                'Required parameter "consignmentId" was null or undefined when calling getConsignmentMetadataById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/consignments/{consignmentId}/metadata`;
        urlPath = urlPath.replace(`{${"consignmentId"}}`, encodeURIComponent(String(requestParameters['consignmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogisticsObjectMetadataFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint retrieves the metadata of a specific Consignment by its `ConsignmentId`.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access this resource. 
     * Get a Consignment metadata by consignmentId
     */
    async getConsignmentMetadataById(requestParameters: GetConsignmentMetadataByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogisticsObjectMetadata> {
        const response = await this.getConsignmentMetadataByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified Consignment, identified by its `ConsignmentId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given Consignment resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a Consignment resource. 
     * Get a list of ChangeRequest for Consignment
     */
    async listChangeRequestsOfConsignmentByIdRaw(requestParameters: ListChangeRequestsOfConsignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedChangeRequests>> {
        if (requestParameters['consignmentId'] == null) {
            throw new runtime.RequiredError(
                'consignmentId',
                'Required parameter "consignmentId" was null or undefined when calling listChangeRequestsOfConsignmentById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/consignments/{consignmentId}/change-requests`;
        urlPath = urlPath.replace(`{${"consignmentId"}}`, encodeURIComponent(String(requestParameters['consignmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedChangeRequestsFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a list of all change requests associated with the specified Consignment, identified by its `ConsignmentId`. This endpoint allows clients to review the history of change requests (such as updates or modifications) that have been submitted for a given Consignment resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of change requests for a Consignment resource. 
     * Get a list of ChangeRequest for Consignment
     */
    async listChangeRequestsOfConsignmentById(requestParameters: ListChangeRequestsOfConsignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedChangeRequests> {
        const response = await this.listChangeRequestsOfConsignmentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing Consignment identified by its `ConsignmentId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a Consignment resource. 
     * Partially update a Consignment by applying a JSON Merge Patch change request
     */
    async patchConsignmentByIdRaw(requestParameters: PatchConsignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConsignmentResponse>> {
        if (requestParameters['consignmentId'] == null) {
            throw new runtime.RequiredError(
                'consignmentId',
                'Required parameter "consignmentId" was null or undefined when calling patchConsignmentById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling patchConsignmentById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling patchConsignmentById().'
            );
        }

        if (requestParameters['consignment'] == null) {
            throw new runtime.RequiredError(
                'consignment',
                'Required parameter "consignment" was null or undefined when calling patchConsignmentById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/consignments/{consignmentId}`;
        urlPath = urlPath.replace(`{${"consignmentId"}}`, encodeURIComponent(String(requestParameters['consignmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ConsignmentToJSON(requestParameters['consignment']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConsignmentResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing Consignment identified by its `ConsignmentId` using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). The patch operation applies partial updates to the resource. The underlying mechanism is the creation of a change-request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a Consignment resource. 
     * Partially update a Consignment by applying a JSON Merge Patch change request
     */
    async patchConsignmentById(requestParameters: PatchConsignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConsignmentResponse> {
        const response = await this.patchConsignmentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of Consignment resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on Consignments.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of Consignment resources. 
     * Search for Consignments
     */
    async searchConsignmentGetRaw(requestParameters: SearchConsignmentGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchConsignmentsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['searchBody'] != null) {
            queryParameters['searchBody'] = requestParameters['searchBody'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/consignments/search`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchConsignmentsResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of Consignment resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on Consignments.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of Consignment resources. 
     * Search for Consignments
     */
    async searchConsignmentGet(requestParameters: SearchConsignmentGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchConsignmentsResponse> {
        const response = await this.searchConsignmentGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  Retrieves a paginated list of Consignment resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on Consignments.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of Consignment resources. 
     * Search for Consignments
     */
    async searchConsignmentsPostRaw(requestParameters: SearchConsignmentsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchConsignmentsResponse>> {
        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling searchConsignmentsPost().'
            );
        }

        if (requestParameters['searchConsignmentsRequest'] == null) {
            throw new runtime.RequiredError(
                'searchConsignmentsRequest',
                'Required parameter "searchConsignmentsRequest" was null or undefined when calling searchConsignmentsPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/consignments/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchConsignmentsRequestToJSON(requestParameters['searchConsignmentsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchConsignmentsResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  Retrieves a paginated list of Consignment resources matching the specified search and filter criteria. This endpoint enables clients to perform advanced queries on Consignments.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Read`. - **ACL Mode**: `READ` mode is required to access the list of Consignment resources. 
     * Search for Consignments
     */
    async searchConsignmentsPost(requestParameters: SearchConsignmentsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchConsignmentsResponse> {
        const response = await this.searchConsignmentsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given Consignment, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a Consignment resource. 
     * Accept or reject a ChangeRequest on a  Consignment using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnConsignmentByIdRaw(requestParameters: UpdateChangeRequestOnConsignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChangeRequest>> {
        if (requestParameters['consignmentId'] == null) {
            throw new runtime.RequiredError(
                'consignmentId',
                'Required parameter "consignmentId" was null or undefined when calling updateChangeRequestOnConsignmentById().'
            );
        }

        if (requestParameters['changeRequestId'] == null) {
            throw new runtime.RequiredError(
                'changeRequestId',
                'Required parameter "changeRequestId" was null or undefined when calling updateChangeRequestOnConsignmentById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updateChangeRequestOnConsignmentById().'
            );
        }

        if (requestParameters['changeRequestPatchRequest'] == null) {
            throw new runtime.RequiredError(
                'changeRequestPatchRequest',
                'Required parameter "changeRequestPatchRequest" was null or undefined when calling updateChangeRequestOnConsignmentById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/consignments/{consignmentId}/change-requests/{changeRequestId}`;
        urlPath = urlPath.replace(`{${"consignmentId"}}`, encodeURIComponent(String(requestParameters['consignmentId'])));
        urlPath = urlPath.replace(`{${"changeRequestId"}}`, encodeURIComponent(String(requestParameters['changeRequestId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: ChangeRequestPatchRequestToJSON(requestParameters['changeRequestPatchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChangeRequestFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows you to accept or reject a specific ChangeRequest associated with a given Consignment, using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396). It enables clients to update the status or details of a ChangeRequest, such as marking it as accepted or rejected, and to apply partial modifications to the resource.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Write`. - **ACL Mode**: `CONTROL` mode is required to accept or reject a ChangeRequest on a Consignment resource. 
     * Accept or reject a ChangeRequest on a  Consignment using JSON Merge Patch as specified in [RFC 7396](https://datatracker.ietf.org/doc/html/rfc7396).
     */
    async updateChangeRequestOnConsignmentById(requestParameters: UpdateChangeRequestOnConsignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChangeRequest> {
        const response = await this.updateChangeRequestOnConsignmentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows updating an existing Consignment identified by its `ConsignmentId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a Consignment resource. 
     * Update an existing Consignment by creating and applying a change request
     */
    async updateConsignmentByIdRaw(requestParameters: UpdateConsignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConsignmentResponse>> {
        if (requestParameters['consignmentId'] == null) {
            throw new runtime.RequiredError(
                'consignmentId',
                'Required parameter "consignmentId" was null or undefined when calling updateConsignmentById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling updateConsignmentById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling updateConsignmentById().'
            );
        }

        if (requestParameters['consignment'] == null) {
            throw new runtime.RequiredError(
                'consignment',
                'Required parameter "consignment" was null or undefined when calling updateConsignmentById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['revision'] != null) {
            queryParameters['revision'] = requestParameters['revision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/consignments/{consignmentId}`;
        urlPath = urlPath.replace(`{${"consignmentId"}}`, encodeURIComponent(String(requestParameters['consignmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ConsignmentToJSON(requestParameters['consignment']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConsignmentResponseFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows updating an existing Consignment identified by its `ConsignmentId`. The underlying mechanism is the creation of a change request, which will then be automatically accepted and applied.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to create a change request on a Consignment resource. 
     * Update an existing Consignment by creating and applying a change request
     */
    async updateConsignmentById(requestParameters: UpdateConsignmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConsignmentResponse> {
        const response = await this.updateConsignmentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific Consignment resource, identified by its `ConsignmentId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a Consignment resource. 
     * Upsert (create or update) an authorization of an access control list of a Consignment.
     */
    async upsertConsignmentACLAuthorizationByIdRaw(requestParameters: UpsertConsignmentACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ACLAuthorization>> {
        if (requestParameters['consignmentId'] == null) {
            throw new runtime.RequiredError(
                'consignmentId',
                'Required parameter "consignmentId" was null or undefined when calling upsertConsignmentACLAuthorizationById().'
            );
        }

        if (requestParameters['contentType'] == null) {
            throw new runtime.RequiredError(
                'contentType',
                'Required parameter "contentType" was null or undefined when calling upsertConsignmentACLAuthorizationById().'
            );
        }

        if (requestParameters['xBOLMemberIdentifier'] == null) {
            throw new runtime.RequiredError(
                'xBOLMemberIdentifier',
                'Required parameter "xBOLMemberIdentifier" was null or undefined when calling upsertConsignmentACLAuthorizationById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aclRevision'] != null) {
            queryParameters['aclRevision'] = requestParameters['aclRevision'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['contentType'] != null) {
            headerParameters['Content-Type'] = String(requestParameters['contentType']);
        }

        if (requestParameters['accept'] != null) {
            headerParameters['Accept'] = String(requestParameters['accept']);
        }

        if (requestParameters['traceparent'] != null) {
            headerParameters['traceparent'] = String(requestParameters['traceparent']);
        }

        if (requestParameters['xBOLMemberIdentifier'] != null) {
            headerParameters['X-BOL-Member-Identifier'] = String(requestParameters['xBOLMemberIdentifier']);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oAuth2Azure", []);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Ocp-Apim-Subscription-Key"] = await this.configuration.apiKey("Ocp-Apim-Subscription-Key"); // APIKey authentication
        }


        let urlPath = `/consignments/{consignmentId}/acl/authorizations`;
        urlPath = urlPath.replace(`{${"consignmentId"}}`, encodeURIComponent(String(requestParameters['consignmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ACLAuthorizationRequestToJSON(requestParameters['aCLAuthorizationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ACLAuthorizationFromJSON(jsonValue));
    }

    /**
     * ## Description  This endpoint allows clients to create or update an authorization in the Access Control List (ACL) of a specific Consignment resource, identified by its `ConsignmentId`.  If an authorization already exists for the given `memberIdentifier`, then this authorization is replaced by this requested new authorization.  The value of the header `X-BOL-Member-Identifier` defines the member that authorized the access. The Member Identifier must be a valid AD Entra ID Object ID of a Member that is part of the authenticated company user.  ## Access Control  - **AD Entra ID Role**: Requires the custom role `BOL.LOGISTICS-OBJECTS.Update`. - **ACL Mode**: `CONTROL` mode is required to add or update authorizations in the ACL of a Consignment resource. 
     * Upsert (create or update) an authorization of an access control list of a Consignment.
     */
    async upsertConsignmentACLAuthorizationById(requestParameters: UpsertConsignmentACLAuthorizationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ACLAuthorization> {
        const response = await this.upsertConsignmentACLAuthorizationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const CreateChangeRequestOnConsignmentByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnConsignmentByIdContentTypeEnum = typeof CreateChangeRequestOnConsignmentByIdContentTypeEnum[keyof typeof CreateChangeRequestOnConsignmentByIdContentTypeEnum];
/**
 * @export
 */
export const CreateChangeRequestOnConsignmentByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateChangeRequestOnConsignmentByIdAcceptEnum = typeof CreateChangeRequestOnConsignmentByIdAcceptEnum[keyof typeof CreateChangeRequestOnConsignmentByIdAcceptEnum];
/**
 * @export
 */
export const CreateConsignmentContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateConsignmentContentTypeEnum = typeof CreateConsignmentContentTypeEnum[keyof typeof CreateConsignmentContentTypeEnum];
/**
 * @export
 */
export const CreateConsignmentAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateConsignmentAcceptEnum = typeof CreateConsignmentAcceptEnum[keyof typeof CreateConsignmentAcceptEnum];
/**
 * @export
 */
export const CreateConsignmentEventContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateConsignmentEventContentTypeEnum = typeof CreateConsignmentEventContentTypeEnum[keyof typeof CreateConsignmentEventContentTypeEnum];
/**
 * @export
 */
export const CreateConsignmentEventAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type CreateConsignmentEventAcceptEnum = typeof CreateConsignmentEventAcceptEnum[keyof typeof CreateConsignmentEventAcceptEnum];
/**
 * @export
 */
export const GetChangeRequestOnConsignmentByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetChangeRequestOnConsignmentByIdAcceptEnum = typeof GetChangeRequestOnConsignmentByIdAcceptEnum[keyof typeof GetChangeRequestOnConsignmentByIdAcceptEnum];
/**
 * @export
 */
export const GetConsignmentACLAuthorizationByMemberIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetConsignmentACLAuthorizationByMemberIdAcceptEnum = typeof GetConsignmentACLAuthorizationByMemberIdAcceptEnum[keyof typeof GetConsignmentACLAuthorizationByMemberIdAcceptEnum];
/**
 * @export
 */
export const GetConsignmentACLByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetConsignmentACLByIdAcceptEnum = typeof GetConsignmentACLByIdAcceptEnum[keyof typeof GetConsignmentACLByIdAcceptEnum];
/**
 * @export
 */
export const GetConsignmentByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetConsignmentByIdAcceptEnum = typeof GetConsignmentByIdAcceptEnum[keyof typeof GetConsignmentByIdAcceptEnum];
/**
 * @export
 */
export const GetConsignmentEventsAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetConsignmentEventsAcceptEnum = typeof GetConsignmentEventsAcceptEnum[keyof typeof GetConsignmentEventsAcceptEnum];
/**
 * @export
 */
export const GetConsignmentMetadataByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type GetConsignmentMetadataByIdAcceptEnum = typeof GetConsignmentMetadataByIdAcceptEnum[keyof typeof GetConsignmentMetadataByIdAcceptEnum];
/**
 * @export
 */
export const ListChangeRequestsOfConsignmentByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type ListChangeRequestsOfConsignmentByIdAcceptEnum = typeof ListChangeRequestsOfConsignmentByIdAcceptEnum[keyof typeof ListChangeRequestsOfConsignmentByIdAcceptEnum];
/**
 * @export
 */
export const PatchConsignmentByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchConsignmentByIdContentTypeEnum = typeof PatchConsignmentByIdContentTypeEnum[keyof typeof PatchConsignmentByIdContentTypeEnum];
/**
 * @export
 */
export const PatchConsignmentByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type PatchConsignmentByIdAcceptEnum = typeof PatchConsignmentByIdAcceptEnum[keyof typeof PatchConsignmentByIdAcceptEnum];
/**
 * @export
 */
export const SearchConsignmentGetAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchConsignmentGetAcceptEnum = typeof SearchConsignmentGetAcceptEnum[keyof typeof SearchConsignmentGetAcceptEnum];
/**
 * @export
 */
export const SearchConsignmentsPostContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchConsignmentsPostContentTypeEnum = typeof SearchConsignmentsPostContentTypeEnum[keyof typeof SearchConsignmentsPostContentTypeEnum];
/**
 * @export
 */
export const SearchConsignmentsPostAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type SearchConsignmentsPostAcceptEnum = typeof SearchConsignmentsPostAcceptEnum[keyof typeof SearchConsignmentsPostAcceptEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnConsignmentByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnConsignmentByIdContentTypeEnum = typeof UpdateChangeRequestOnConsignmentByIdContentTypeEnum[keyof typeof UpdateChangeRequestOnConsignmentByIdContentTypeEnum];
/**
 * @export
 */
export const UpdateChangeRequestOnConsignmentByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateChangeRequestOnConsignmentByIdAcceptEnum = typeof UpdateChangeRequestOnConsignmentByIdAcceptEnum[keyof typeof UpdateChangeRequestOnConsignmentByIdAcceptEnum];
/**
 * @export
 */
export const UpdateConsignmentByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateConsignmentByIdContentTypeEnum = typeof UpdateConsignmentByIdContentTypeEnum[keyof typeof UpdateConsignmentByIdContentTypeEnum];
/**
 * @export
 */
export const UpdateConsignmentByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpdateConsignmentByIdAcceptEnum = typeof UpdateConsignmentByIdAcceptEnum[keyof typeof UpdateConsignmentByIdAcceptEnum];
/**
 * @export
 */
export const UpsertConsignmentACLAuthorizationByIdContentTypeEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertConsignmentACLAuthorizationByIdContentTypeEnum = typeof UpsertConsignmentACLAuthorizationByIdContentTypeEnum[keyof typeof UpsertConsignmentACLAuthorizationByIdContentTypeEnum];
/**
 * @export
 */
export const UpsertConsignmentACLAuthorizationByIdAcceptEnum = {
    ApplicationJson: 'application/json'
} as const;
export type UpsertConsignmentACLAuthorizationByIdAcceptEnum = typeof UpsertConsignmentACLAuthorizationByIdAcceptEnum[keyof typeof UpsertConsignmentACLAuthorizationByIdAcceptEnum];
